import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function MentionsLegalesPage() {
  const handleDownload = () => {
    const content = document.getElementById('legal-content');
    if (!content) return;

    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <title>Mentions Légales - Clinique Sainte Famille</title>
          <style>
            @page { 
              margin: 2cm; 
              size: A4;
            }
            body { 
              font-family: Arial, sans-serif; 
              padding: 0; 
              margin: 0;
              line-height: 1.6; 
              color: #333; 
              font-size: 12px;
            }
            h1 { 
              color: #1e40af; 
              font-size: 24px; 
              margin-bottom: 20px; 
              page-break-after: avoid;
            }
            h2 { 
              color: #1e40af; 
              font-size: 18px; 
              margin-top: 25px; 
              margin-bottom: 12px; 
              page-break-after: avoid;
            }
            h3 { 
              color: #1e40af; 
              font-size: 14px; 
              margin-top: 15px; 
              margin-bottom: 8px; 
              page-break-after: avoid;
            }
            p, li { 
              margin-bottom: 8px; 
              page-break-inside: avoid;
            }
            ul { 
              margin-left: 20px; 
            }
            .info-box { 
              background: #f8f9fa; 
              padding: 12px; 
              border-left: 4px solid #1e40af;
              margin: 12px 0; 
              page-break-inside: avoid;
            }
            .grid { 
              display: block; 
            }
            .grid > div { 
              margin-bottom: 10px; 
              page-break-inside: avoid;
            }
            section { 
              page-break-inside: avoid; 
              margin-bottom: 20px;
            }
            @media print {
              body { print-color-adjust: exact; }
            }
          </style>
        </head>
        <body>
          ${content.innerHTML}
        </body>
      </html>
    `;

    const blob = new Blob([printContent], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Mentions-Legales-Clinique-Sainte-Famille.html';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 100);

    const notification = document.createElement('div');
    notification.className = 'fixed bottom-4 right-4 bg-clinic-green text-white px-6 py-3 rounded-full shadow-lg z-50 flex items-center gap-2';
    notification.innerHTML = '<i class="ri-check-line"></i> Fichier téléchargé avec succès';
    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 3000);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />

      <div className="flex-1 py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="mb-6 flex items-center justify-between">
            <button
              onClick={handleDownload}
              className="flex items-center gap-2 px-6 py-3 bg-clinic-blue text-white rounded-full hover:bg-clinic-blue-dark transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line text-lg"></i>
              Télécharger en PDF
            </button>
          </div>
          <div className="bg-white rounded-3xl shadow-xl border-2 border-clinic-blue/10 p-8 md:p-12" id="legal-content">
            <div className="mb-8">
              <div className="w-16 h-16 bg-clinic-blue/10 rounded-2xl flex items-center justify-center mb-4">
                <i className="ri-file-text-line text-3xl text-clinic-blue"></i>
              </div>
              <h1 className="text-4xl font-bold text-clinic-blue-dark mb-2">Mentions Légales</h1>
              <p className="text-gray-600">Informations légales et réglementaires</p>
            </div>

            <div className="prose prose-lg max-w-none space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">1. Éditeur du Site</h2>
                <div className="bg-gray-50 p-6 rounded-2xl space-y-2">
                  <p className="text-gray-700"><strong>Raison sociale :</strong> Clinique Sainte Famille</p>
                  <p className="text-gray-700"><strong>Forme juridique :</strong> Établissement de santé privé</p>
                  <p className="text-gray-700"><strong>Adresse :</strong> 99QX+7W, Cotonou Bénin - 04 BP 127 lot 1862 Fifadji</p>
                  <p className="text-gray-700"><strong>Téléphone :</strong> +229 01 95 40 58 91 / +229 01 94 27 54 24</p>
                  <p className="text-gray-700"><strong>Email :</strong> clinicfam@yahoo.com</p>
                  <p className="text-gray-700"><strong>Directeur de publication :</strong> Direction de la Clinique Sainte Famille</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">2. Hébergement</h2>
                <div className="bg-gray-50 p-6 rounded-2xl space-y-2">
                  <p className="text-gray-700"><strong>Hébergeur :</strong> Supabase Inc.</p>
                  <p className="text-gray-700"><strong>Adresse :</strong> 970 Toa Payoh North, #07-04, Singapore 318992</p>
                  <p className="text-gray-700"><strong>Site web :</strong> <a href="https://supabase.com" target="_blank" rel="noopener noreferrer" className="text-clinic-blue hover:underline">www.supabase.com</a></p>
                </div>
                <div className="bg-clinic-blue/5 border-l-4 border-clinic-blue p-4 rounded-lg mt-4">
                  <p className="text-sm text-clinic-blue-dark">
                    <i className="ri-information-line mr-2"></i>
                    Les données de santé sont hébergées sur des serveurs sécurisés conformes aux normes de protection des données médicales.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">3. Propriété Intellectuelle</h2>
                <p className="text-gray-700 mb-4">
                  L'ensemble du contenu de ce site (textes, images, logos, vidéos, structure, design) est la propriété exclusive 
                  de la Clinique Sainte Famille ou de ses partenaires.
                </p>
                <p className="text-gray-700 mb-4">
                  Toute reproduction, distribution, modification, adaptation, retransmission ou publication de ces différents éléments 
                  est strictement interdite sans l'accord écrit préalable de la Clinique Sainte Famille.
                </p>
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg">
                  <p className="text-sm text-yellow-800">
                    <i className="ri-alert-line mr-2"></i>
                    Toute utilisation non autorisée du site ou de l'un de ses éléments sera considérée comme constitutive d'une contrefaçon 
                    et poursuivie conformément aux dispositions légales en vigueur.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">4. Autorisation d'Exercice</h2>
                <div className="bg-clinic-green/10 border-2 border-clinic-green/30 p-6 rounded-2xl">
                  <p className="text-gray-700 mb-3">
                    La Clinique Sainte Famille est un établissement de santé autorisé à exercer au Bénin, conformément à la réglementation 
                    en vigueur en matière d'établissements de soins.
                  </p>
                  <p className="text-gray-700 mb-3">
                    <strong>Autorisation d'ouverture :</strong> Délivrée par le Ministère de la Santé de la République du Bénin
                  </p>
                  <p className="text-gray-700">
                    <strong>Activités autorisées :</strong> Consultations médicales, soins ambulatoires, hospitalisation, urgences médicales
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">5. Protection des Données Personnelles</h2>
                <p className="text-gray-700 mb-4">
                  Conformément à la <strong>loi n°2017-20 du Bénin sur la protection des données personnelles</strong>, 
                  la Clinique Sainte Famille s'engage à protéger vos données personnelles et médicales.
                </p>
                <p className="text-gray-700 mb-4">
                  Le traitement de vos données a été déclaré auprès de l'<strong>Autorité de Protection des Données Personnelles (APDP)</strong>.
                </p>
                <p className="text-gray-700">
                  Pour plus d'informations, consultez notre <a href="/politique-confidentialite" className="text-clinic-blue hover:underline font-semibold">Politique de Confidentialité</a>.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">6. Responsabilité</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">6.1 Contenu du Site</h3>
                    <p className="text-gray-700">
                      La Clinique Sainte Famille s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. 
                      Toutefois, elle ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition.
                    </p>
                  </div>

                  <div>
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">6.2 Utilisation du Site</h3>
                    <p className="text-gray-700">
                      L'utilisateur est seul responsable de l'utilisation qu'il fait du site et des informations qu'il y consulte. 
                      Les informations médicales présentes sur le site ne remplacent en aucun cas une consultation médicale.
                    </p>
                  </div>

                  <div>
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">6.3 Disponibilité du Site</h3>
                    <p className="text-gray-700">
                      La Clinique Sainte Famille met tout en œuvre pour assurer la disponibilité du site 24h/24 et 7j/7. 
                      Toutefois, elle ne peut être tenue responsable en cas d'interruption temporaire du service pour des raisons 
                      de maintenance ou de force majeure.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">7. Liens Hypertextes</h2>
                <p className="text-gray-700 mb-4">
                  Le site peut contenir des liens vers d'autres sites internet. La Clinique Sainte Famille n'exerce aucun contrôle 
                  sur ces sites et décline toute responsabilité quant à leur contenu.
                </p>
                <p className="text-gray-700">
                  La création de liens hypertextes vers le site de la Clinique Sainte Famille nécessite une autorisation préalable écrite.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">8. Cookies</h2>
                <p className="text-gray-700 mb-4">
                  Le site utilise des cookies pour améliorer l'expérience utilisateur et assurer la sécurité des connexions.
                </p>
                <p className="text-gray-700">
                  Pour plus d'informations, consultez notre <a href="/gestion-cookies" className="text-clinic-blue hover:underline font-semibold">Politique de Gestion des Cookies</a>.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">9. Droit Applicable et Juridiction</h2>
                <div className="bg-gray-50 p-6 rounded-2xl">
                  <p className="text-gray-700 mb-3">
                    <strong>Droit applicable :</strong> Les présentes mentions légales sont régies par le droit béninois.
                  </p>
                  <p className="text-gray-700">
                    <strong>Juridiction compétente :</strong> En cas de litige, et à défaut de résolution amiable, 
                    les tribunaux de Cotonou (Bénin) seront seuls compétents.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">10. Secret Médical</h2>
                <div className="bg-clinic-blue/5 border-2 border-clinic-blue/20 p-6 rounded-2xl">
                  <p className="text-gray-700 mb-3">
                    Tous les professionnels de santé exerçant au sein de la Clinique Sainte Famille sont soumis au secret médical 
                    conformément aux dispositions du Code de déontologie médicale et de la législation béninoise.
                  </p>
                  <p className="text-gray-700">
                    Les informations médicales vous concernant sont strictement confidentielles et ne peuvent être divulguées 
                    qu'avec votre consentement explicite ou dans les cas prévus par la loi.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">11. Médiation</h2>
                <p className="text-gray-700 mb-4">
                  En cas de litige relatif à l'utilisation du site ou aux services fournis par la Clinique Sainte Famille, 
                  nous vous encourageons à nous contacter en priorité pour trouver une solution amiable.
                </p>
                <p className="text-gray-700">
                  Si aucune solution amiable n'est trouvée, vous pouvez recourir à une procédure de médiation ou saisir 
                  les juridictions compétentes.
                </p>
              </section>

              <section className="bg-clinic-blue/5 p-6 rounded-2xl border-2 border-clinic-blue/20">
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">Contact</h2>
                <p className="text-gray-700 mb-4">
                  Pour toute question concernant ces mentions légales :
                </p>
                <div className="space-y-2 text-gray-700">
                  <p><i className="ri-mail-line mr-2 text-clinic-blue"></i><strong>Email :</strong> clinicfam@yahoo.com</p>
                  <p><i className="ri-phone-line mr-2 text-clinic-blue"></i><strong>Téléphone :</strong> +229 01 95 40 58 91</p>
                  <p><i className="ri-map-pin-line mr-2 text-clinic-blue"></i><strong>Adresse :</strong> 99QX+7W, Cotonou Bénin - 04 BP 127 lot 1862 Fifadji</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
